import { render, staticRenderFns } from "./minip-list.vue?vue&type=template&id=767851fe&scoped=true"
import script from "./minip-list.vue?vue&type=script&lang=js"
export * from "./minip-list.vue?vue&type=script&lang=js"
import style0 from "./minip-list.vue?vue&type=style&index=0&id=767851fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767851fe",
  null
  
)

export default component.exports